// extracted by mini-css-extract-plugin
export default {"highlightButton":"index_highlightButton__RnKax"};